import React, { FC, PropsWithChildren } from "react";

interface MountingComponentProps {
  conditions: boolean[];
}

export const MountingComponent: FC<PropsWithChildren<MountingComponentProps>> = (props) => {
  const { conditions, children } = props;

  if (conditions.every((c) => !!c)) {
    return <>{children}</>;
  }

  return null;
};
